export default {
    manufacturer: 'Producent',
    reseller: 'Forhandler',
}


// WEBPACK FOOTER //
// ./web/src/common/productSellTypes.js